import * as React from "react"
import * as styles from "./styles.module.scss"
import moment from "moment"

export interface HeaderProps {
  date: string
  author: string
  title: string
  avatarSrc?: string
  avatarAlt: string
}

const Header: React.FC<HeaderProps> = ({
  author,
  date,
  title,
  avatarSrc,
  avatarAlt,
}) => {
  const formattedDate = moment(date).format("MMM D, YYYY")
  return (
    <header className={styles.postHeader}>
      <h1 className={styles.heading}>{title}</h1>
      <div className={styles.meta}>
        {avatarSrc && (
          <figure className={styles.figure}>
            <img className={styles.image} src={avatarSrc} alt={avatarAlt} />
          </figure>
        )}

        <div className={styles.nameTimeWrap}>
          <address className={styles.nameWrap}>
            <span>By</span>
            <span className={styles.name}> {author}</span>
          </address>
          <time className={styles.time} dateTime={date}>
            {formattedDate}
          </time>
        </div>
      </div>
    </header>
  )
}

export default Header
